import { useMemo, useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { discussions } from '@/mocks/content';

const boards = ['全部', ...Array.from(new Set(discussions.map((item) => item.board)))];

export default function Community() {
  const [board, setBoard] = useState('全部');

  const list = useMemo(
    () => (board === '全部' ? discussions : discussions.filter((item) => item.board === board)),
    [board],
  );

  return (
    <section id="community" className="py-12 md:py-16 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="社区讨论"
          title="社区讨论：看完之后，和大家聊聊细节"
          desc="有人分享背景资料，有人补充实测经验，也有人单纯来吐槽。按板块切换，看看最近大家在聊什么。"
        />

        <div className="mt-6 flex flex-wrap gap-2 dv-reveal">
          {boards.map((item) => {
            const active = item === board;
            return (
              <button
                key={item}
                type="button"
                onClick={() => setBoard(item)}
                aria-pressed={active}
                className={`rounded-full px-3.5 py-1.5 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  active
                    ? 'bg-secondary-500 text-background-50'
                    : 'border border-background-300 bg-background-50 text-foreground-700 hover:border-secondary-300 hover:text-secondary-800'
                }`}
              >
                {item}
              </button>
            );
          })}
        </div>

        <div className="mt-5 grid grid-cols-1 lg:grid-cols-2 gap-4">
          {list.map((item, index) => (
            <article
              key={item.id}
              className={`flex gap-4 rounded-lg border p-4 md:p-5 transition-transform duration-300 hover:-translate-y-1 ${
                index === 0 ? 'border-accent-300 bg-accent-50' : 'border-background-200 bg-background-50'
              }`}
            >
              <span className="w-11 h-11 flex-none flex items-center justify-center rounded-full bg-primary-100 font-heading text-lg font-bold text-primary-700">
                {item.initial}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                    {item.board}
                  </span>
                  <span className="text-[11px] text-foreground-500">{item.time}</span>
                </div>
                <h3 className="mt-2 font-heading text-sm md:text-base font-bold leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600 line-clamp-2">
                  {item.excerpt}
                </p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-user-line" /> {item.author}
                  </span>
                  <span className="inline-flex items-center gap-3">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-chat-1-line" /> {item.replies}
                    </span>
                    <span className="inline-flex items-center gap-1 text-primary-700">
                      <i className="ri-thumb-up-line" /> {item.likes}
                    </span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}